import React from 'react';
import type { Props as TextFieldProps } from 'view/common/fields/text-field';
import { TextField } from 'view/common/fields/text-field';

export type PciSecureTextPickerProps = Omit<TextFieldProps, 'shouldFitContainer'>;

/** Editable secure text. A later SDK will add mount, unmount, isValid, and submit. */
export const PciSecureTextPicker = (props: PciSecureTextPickerProps) => (
	<TextField {...props} shouldFitContainer />
);
